import { ResponseBase } from '../commonModels';
import { SearchBaseModel } from '../commonModels';

export class MapMarker {
    Lat: number;
    Lng: number;
    Label?: string;
    Draggable: boolean;
    Title: string;
    Address?: string;
    Phone?: string;
    Www: string;
    Distance?: string;
}


export class MapMarkerResponseModel extends ResponseBase {
    Location: MapMarker;
    Distance: string;
}


export class MapAddressRequestModel extends SearchBaseModel {
    Address: string;
    Address2: string;
    constructor() {
        super();
        this.Address = null;
        this.Address2 = null;
    }
}


